import { render } from "./InStockDetail.vue?vue&type=template&id=955edc42&scoped=true"
import script from "./InStockDetail.vue?vue&type=script&lang=js"
export * from "./InStockDetail.vue?vue&type=script&lang=js"

import "./InStockDetail.vue?vue&type=style&index=0&id=955edc42&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955edc42"],['__file',"src/views/h5/common/stock/inStock/InStockDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "955edc42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('955edc42', __exports__)) {
    api.reload('955edc42', __exports__)
  }
  
  module.hot.accept("./InStockDetail.vue?vue&type=template&id=955edc42&scoped=true", () => {
    api.rerender('955edc42', render)
  })

}


export default __exports__